import http from './http'

const SAAS_API = '/saas_api.php'

/**
 * SaaS 商标列表（vueself / vuesass 共用）
 */
export function fetchTrademarkList(params = {}) {
  return http.get(SAAS_API, {
    params: { action: 'list', ...params }
  }).then(result => {
    if (result.status !== 1 || !result.data) {
      return result
    }

    const data = result.data
    const pagination = data.pagination || {
      page: data.pageNo,
      pageSize: data.pageSize,
      total: data.totalCount,
      totalPages: data.totalPage
    }

    return {
      status: 1,
      data: {
        list: data.list || [],
        pagination
      }
    }
  })
}

/**
 * SaaS 商标详情
 */
export function fetchTrademarkDetail(proId) {
  return http.get(SAAS_API, {
    params: {
      action: 'detail',
      pro_id: proId
    }
  })
}

/**
 * SaaS 租户顾问联系方式
 */
export function fetchTenantContact() {
  return http.get(SAAS_API, {
    params: { action: 'get_contact' }
  })
}
